import { authApi, formData } from 'utils'


export const saveNotificationSettings = (settings) => () =>
    authApi.post(`/settings/user/notifications`, formData(settings)).then(res => {
      if (res.status === 200) {
        return res
      } else {
        throw res
      }
    }).catch(err => {
      throw err
    })

export const checkDiscordChannel = (channel) => () => {
    return authApi.post(`/discord/try/webhook`, formData(channel)).then(res => {
        if (res && res.status === 200) {
            return res
        } else {
            throw res
        }
    }).catch(err => {
        throw err
    })
}